import { Component, Host, h, Element } from '@stencil/core';

/**
 * Used to group multiple `aha-chart-tooltip` components together in a chart tooltip.
 * This component sets the border radius so multiple tooltips can be displayed together.
 * @slot default - Multiple `aha-chart-tooltip` components
 */
@Component({
  tag: 'aha-chart-tooltip-group',
  styleUrl: 'aha-chart-tooltip-group.css',
  shadow: true,
})
export class AhaChartTooltipGroup {
  @Element() host!: HTMLAhaChartTooltipGroupElement;
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
